import { Box, CircularProgress } from '@mui/material'
import React from 'react'

/* Styles */
const PAGE_LOADER_STYLE = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100%',
}

const PageLoader: React.FC<unknown> = () => {
  return (
    <Box sx={PAGE_LOADER_STYLE} data-testid='page-loader'>
      <CircularProgress size='3rem' />
    </Box>
  )
}

export default PageLoader
